/**
 * A wrapper for ES function Object.keys() which improves typing such that the type of the returned
 * array is correctly inferred from the actual keys being used by the given object
 *
 * Example:
 * getObjectKeys({ a: 10, b: 20 }) satisfies Array<'a' | 'b'>;
 */
export function getObjectKeys<K extends string>(object: Record<K, unknown>): K[] {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- see https://github.com/colinhacks/zod/discussions/839
  return Object.keys(object) as K[];
}
